<template>
  <layout-base page-title="Settings" :showDrawer="false" class="settings">
    <md-content class="content-container">
      <div class="md-layout md-gutter">
        <div class="md-layout-item md-small-size-15 md-size-20">
            <md-list class="md-dense">
              <router-link to="/settings/profile">
                <md-list-item>
                  <span class="settings-page-name">
                    Profile
                  </span>
                </md-list-item>
              </router-link>
              <router-link to="/settings/account">
                <md-list-item>
                  <span class="settings-page-name">
                    Account
                  </span>
                </md-list-item>
              </router-link>
          </md-list>
        </div>
        <div class="md-layout-item settings-container">
          <router-view></router-view>
        </div>
        <div class="md-layout-item md-small-size-15 md-size-20">
        </div>
      </div>
    </md-content>
  </layout-base>
</template>

<script>
import LayoutBase from '../layout/LayoutBase'
export default {
  name: 'Settings',
  components: {
    LayoutBase
  },
  computed: {
    currentRoute () {
      return this.$route
    }
  },
  methods: {
    getClassesForRoute (path) {
      const router = this.$router
      const { location } = router.resolve(path, this.currentRoute, null)
      if (location.path === this.currentRoute.path) {
        return 'router-link-exact-active router-link-active'
      }
      return ''
    }
  }
}
</script>

<style lang="scss" scoped>
  @import '../../assets/theme.scss';
  $list-item-height: 40px;
  $corner-radius: $list-item-height/2;
  .content-container {
    padding-left: 0;
    padding-top: 20px;
    min-height: 100%;
  }
  .settings-container {
    padding-right: 50px;
    padding-left: 50px;
  }
  .md-list-item {
    border-radius: 0 $corner-radius $corner-radius 0;
    padding-right: $corner-radius;
    margin-left: -2px;
  }
  .md-list-item:hover {
    @include background-opacity(black, 0.05);
  }
  .router-link-exact-active .md-list-item {
    @include background-opacity($primary, 0.1);
  }
  .router-link-exact-active .settings-page-name {
    color: $primary;
    font-weight: 600;
  }
</style>



// WEBPACK FOOTER //
// src/components/views/Settings.vue